export default "__VITE_ASSET__6c4aa5ec__"